
import { Model } from '../../model/model';
import { MatrixCallParam, MatrixVO } from '@wizeoo/akm-compute-lib';
import { cloneDeep } from 'lodash-es';
import { MatrixEngine as BaseMatrixEngine} from '@wizeoo/akm-compute-lib';
import { AkmBDD } from '@wizeoo/akm-worker-lib';

/**
 * Manager des matrices de données
 */
export class MatrixEngine extends BaseMatrixEngine {

  constructor(model: Model) {
      super(model);
  }

  public get model(): Model {
    return this._model as Model;
  }


  /**
   * Clone d'une matrice de données pour édition
   * @param m la matrice à cloner
   * @return MatrixVO,  Un clone
   */
  public clone(m: MatrixVO): MatrixVO {
    const clone = new MatrixVO(this._model, cloneDeep(m.source));
    return clone;
  }

  /** création d'une nouvelle matrice */
  public buildFake(): MatrixVO {
    const result: MatrixVO = new MatrixVO(this._model);
    result.domain = this.model.domainCode;
    result.businessUnitCode = this.model.businessUnitCode;
    return result;
  }

  /**
   * exécution de requêtes Dexie sur la table des matrices
   * @param widgetCell (widgetCell) la cellule cible pour le résultat
   * @param targetColumn la colonne cible
   * @param datakind: string type pour cast
   * @param query 
   * @returns 
   */
  public async runQuery(widgetCell: any, targetColumn: string, datakind: string, query: string): Promise<MatrixCallParam> {
    
    try {
      const fn = new Function('db', `
        return (async () => {
          return ${query};
        })();
      `);

      
      let result: any[] = await fn(AkmBDD.getInstance());
      // console.log('runQuery', widgetCell, result);
      return {widgetCell, targetColumn, datakind, query, result};

    } catch (e) {
      throw e;
    }
  }


}
